import { Pagination, PaginationItem, Stack } from "@mui/material";
import type React from "react";

export type BasePaginationProps = {
  page: number;
  perPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
};
export const BasePagination: React.FC<BasePaginationProps> = (props) => {
  const count = Math.ceil(props.totalCount / props.perPage);
  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Pagination
        count={count}
        page={props.page}
        siblingCount={2}
        boundaryCount={2}
        variant="outlined"
        shape="rounded"
        onChange={(_, page) => {
          props.onPageChange(page);
        }}
        renderItem={(item) => {
          const isNext = item.type === "next";
          const isPrev = item.type === "previous";
          return (
            <PaginationItem
              sx={{
                margin: "0",
                borderTopLeftRadius: isPrev ? "40px" : "0px",
                borderBottomLeftRadius: isPrev ? "40px" : "0px",
                borderTopRightRadius: isNext ? "40px" : "0px",
                borderBottomRightRadius: isNext ? "40px" : "0px",
                color: "grey.700",
                "&.Mui-selected": {
                  bgcolor: "grey.100",
                },
              }}
              {...item}
            />
          );
        }}
      />
    </Stack>
  );
};
